var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-1-4" }, [
    _c(
      "div",
      {
        staticClass: "w-2 flex flex-wrap h-2 cursor-pointer items-center",
        attrs: { tabindex: "0" },
        on: {
          click: function($event) {
            return _vm.$emit("open-menu")
          },
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("open-menu")
          }
        }
      },
      [
        _c("div", { staticClass: "w-full h-px border border-brand bg-brand" }),
        _c("div", { staticClass: "w-full h-px border border-brand bg-brand" }),
        _c("div", { staticClass: "w-full h-px border border-brand bg-brand" })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }